import { useCallback, useRef, useState } from 'react'
import { DSL } from './config'

const getAllYacQueryOperate = (childQueries, query) => {
  childQueries.forEach((c) => {
    if (c.yacQueryOperate) {
      query.push(c.yacQueryOperate)
    } else if (Array.isArray(c.childQueries)) {
      getAllYacQueryOperate(c.childQueries, query)
    }
  })
}

export const getDslType = (dsl) => {
  try {
    const yacQueryOperate = []
    getAllYacQueryOperate(dsl.childQueries, yacQueryOperate)
    if (yacQueryOperate.every((o) => o.left.slug === 'isFakeDeleted')) {
      return DSL.ALL
    }

    if (yacQueryOperate.every((o) => o.left.slug === 'objectId')) {
      return DSL.SELECT
    }

    return DSL.QUERY
  } catch (err) {
    return DSL.ALL
  }
}

export const useLazyLoading = (ms = 500) => {
  const [loading, setLoading] = useState(false)
  const cacheRef = useRef(false)

  const setLazyLoading = useCallback((v) => {
    cacheRef.current = v
    if (v) {
      setTimeout(() => {
        setLoading(cacheRef.current)
      }, ms)
    } else {
      setLoading(v)
    }
  }, [])

  return [loading, setLazyLoading]
}
